import React from 'react'
import type { User } from '@supabase/supabase-js'
import { AuthContext, type AuthContextType } from '@/contexts/AuthContext'

// The public demo has no accounts: every visitor browses as the same person,
// who is not a worker (no notifications) and not an admin (no admin menu).
const DEMO_USER = {
    id: 'demo-visitor',
    user_metadata: { full_name: 'Visiteur' },
} as unknown as User

const DEMO_PROFILE = { id: 'demo-visitor', worker_id: null, is_admin: false }

const unavailable = async () => ({ data: null, error: { message: 'Indisponible dans la démo' } })

const DEMO_SESSION: AuthContextType = {
    user: DEMO_USER,
    session: null,
    userProfile: DEMO_PROFILE,
    loading: false,
    profileLoading: false,
    profileNotFound: false,
    signIn: unavailable,
    signUp: unavailable,
    signOut: async () => undefined,
    resetPassword: unavailable,
}

export const DemoAuthProvider = ({ children }: { children: React.ReactNode }) => (
    <AuthContext.Provider value={DEMO_SESSION}>{children}</AuthContext.Provider>
)
